import { legacyRoutes } from './legacy-routes';
import { appRoutes } from './shared/routes/app-routes';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthComponent } from './core/auth/auth.component';
import { ErrorPageComponent } from './core/error-page/error-page.component';
import { PublicFormGuard } from './shared/guards/public-form.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { localhostOnlyGuard } from './dev/dev.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: appRoutes.events.list().join('/')
  },
  {
    path: 'auth/callback',
    component: AuthComponent,
    data: { title: 'Entrando… - SpotPass' }
  },
  {
    path: 'cadastro-publico/:id',
    loadChildren: () => import('./public-form/public-form.module').then(m => m.PublicFormModule),
    data: { public: true, title: 'Cadastro Público de Clientes - SpotPass' },
    canActivate: [PublicFormGuard]
  },
  {
    path: 'dev',
    loadChildren: () => import('./dev/dev.module').then((m) => m.DevModule),
    canMatch: [localhostOnlyGuard]
  },
  {
    path: 'acesso-negado',
    component: ErrorPageComponent,
    data: { errorType: 'forbidden', title: 'Acesso restrito - SpotPass' }
  },
  ...legacyRoutes,
  {
    path: '',
    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    component: ErrorPageComponent,
    data: { errorType: 'not-found', title: 'Página não encontrada - SpotPass' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
